import { call, takeLatest } from "redux-saga/effects";
import * as translateApis from "../apis/translateApis"
import { BATCH_TRANSLATE_DOC, BATCH_TRANSLATE_DOC_MORE_THAN_20, GET_SIGNED_URL, GLOSSARY_DROP_DOWN, HTML_FILE_TRANSLATE, RECENT_TRANSLATIONS, RECENT_VIEW, TRANSLATE_DOC, UPLOAD_FILE, VIEW_BATCH_TRANSLATE_DOC, VIEW_DOC } from "../actions/types";

export function* uploadFileWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(translateApis.uploadFileApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateDocWorker(action) {
    try {
        const res = yield call(translateApis.translateDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateBatchDocWorker(action) {
    try {
        const res = yield call(translateApis.batchTranslateDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateBatcViewhDocWorker(action) {
    try {
        const res = yield call(translateApis.batchTranslateViewDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewhDocWorker(action) {
    try {
        const res = yield call(translateApis.viewDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* glossaryDropDownWorker(action) {
    try {
        const res = yield call(translateApis.glossaryDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* recentTranslationsWorker(action) {
    try {
        const res = yield call(translateApis.recentTranslationsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* recentViewWorker(action) {
    try {
        const res = yield call(translateApis.recentViewApi, {
            id: action.id,
        });
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateBatchMoreThan20DocWorker(action) {
    try {
        const res = yield call(translateApis.batchTranslateMoreThan20DocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getSignedUrlWorker(action) {
    try {
        const res = yield call(translateApis.getSignedUrlAPi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* htmlFileTranslateWorker(action) {
    try {
        const res = yield call(translateApis.htmlFileTranslateApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher functions */

export function* uploadFileWatcher() {
    yield takeLatest(UPLOAD_FILE, uploadFileWorker);
}

export function* translateDocWatcher() {
    yield takeLatest(TRANSLATE_DOC, translateDocWorker);
}

export function* translateBatchDocWatcher() {
    yield takeLatest(BATCH_TRANSLATE_DOC, translateBatchDocWorker);
}

export function* translateBatchViewDocWatcher() {
    yield takeLatest(VIEW_BATCH_TRANSLATE_DOC, translateBatcViewhDocWorker);
}

export function* viewDocWatcher() {
    yield takeLatest(VIEW_DOC, viewhDocWorker);
}

export function* glossaryDropDownWatcher() {
    yield takeLatest(GLOSSARY_DROP_DOWN, glossaryDropDownWorker);
}

export function* recentTranslationsWatcher() {
    yield takeLatest(RECENT_TRANSLATIONS, recentTranslationsWorker);
}

export function* recentViewWatcher() {
    yield takeLatest(RECENT_VIEW, recentViewWorker);
}

export function* translateBatchMoreThan20DocWatcher() {
    yield takeLatest(BATCH_TRANSLATE_DOC_MORE_THAN_20, translateBatchMoreThan20DocWorker);
}

export function* getSignedUrlWatcher() {
    yield takeLatest(GET_SIGNED_URL, getSignedUrlWorker);
}

export function* htmlFileTranslateWatcher() {
    yield takeLatest(HTML_FILE_TRANSLATE, htmlFileTranslateWorker);
}